


















































import { Component, Vue, PropSync } from 'vue-property-decorator'
import { CustomerInfo } from '@/domain/CustomerInfo'
import { AgencyInfo } from '@/domain/AgencyInfo'
import CustomersService from '@/service/CustomersService'

@Component
export default class AgencySelectDialogComponent extends Vue {
  customersService = CustomersService.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "代理店名", value: "customerShortName" },
          { text: "部署名", value: "customerDepartment" },
          { text: "電話番号", value: "customerTel" },
          { text: '', value: 'data-table-expand' },
  ]
  itemsPerPage = 10
  expanded = []
  /** 検索キーワード */
  search = ""
  /** データテーブル フッター設定 */
  footerProps = {
    'disable-items-per-page': true,
    showFirstLastPage: true,
    firstIcon: 'mdi-skip-backward',
    lastIcon: 'mdi-skip-forward',
    prevIcon: 'mdi-skip-previous',
    nextIcon: 'mdi-skip-next'
  }
  list: CustomerInfo[] = []
  selected: CustomerInfo[] = []

  mounted () {
    this.customersService.findAgencyAll().then(x => this.list = x)
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    const customer = this.selected[0]
    const agency = new AgencyInfo({agencyPrefectureCode: customer.customerPrefectureCode,
                                   agencyCode: customer.customerCode,
                                   agencyBranchNumber: customer.customerBranchNumber,
                                   agencyName: customer.customerName,
                                   agencyShortName: customer.customerShortName})
    this.dialog = false
    this.$emit("input", agency)
  }
}
